import React from 'react';
import _ from 'lodash';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import {
  withStyles,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Table,
  Typography,
} from '@material-ui/core';
import { observer, inject } from 'mobx-react';

import { FormField2 } from 'components';
import styles from './styles';

class RulesDependencyTable extends React.Component {

  onChange({ name, value }) {
    const { dependencies = [], onChange } = this.props;

    let selectedDependencies = [ ...dependencies ];

    if (value) {
      // Checked
      selectedDependencies.push(name);
    } else {
      // Unchecked
      const idx = _.indexOf(selectedDependencies, name);
      selectedDependencies.splice(idx, 1);
    }

    onChange(selectedDependencies);
  }

  render() {
    const { classes, dependencies, currentRule } = this.props;
    const { record } = this.props.store;

    // All rules except current
    const rules = !currentRule 
      ? record.rules 
      : _.filter(record.rules, r => r.rule !== currentRule);

    return (
      <div className={classes.root}>
        <Typography variant="body2" style={{ marginBottom: 5, fontWeight: 'bold' }}>
          {this.props.title}      
        </Typography>

        <TableContainer style={{ maxHeight: '150px' }}>
          <Table size="small" className={classes.table}>
            <TableBody>
              {_.map(rules, rule => (
                <TableRow key={`rules-dep-${rule.rule}`}>
                  <TableCell>
                    {rule.title}
                  </TableCell>
                  <TableCell>
                    <FormField2
                      type="checkbox"
                      name={rule.rule}
                      value={_.includes(dependencies, rule.rule)}
                      onChange={this.onChange.bind(this)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    )
  }
}

export default compose(withStyles(styles), inject('store'), withTranslation())(observer(RulesDependencyTable));
